import axios from "axios"

export const getAccountHeadList = () => {
  const response = axios({
    url:"/leader/account-head",
    method:"get",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    if(response.data.success){
      return {success:true,data:response.data.data}
    }else{
      return {success:false, message:response.data.message}
    }  
  })
  return response
}

export const getGroupList = (ledgerGroupId) => {
  const response = axios({
    url:`ledger-groups/get-children/${ledgerGroupId}`,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    if(response.data.success){
      return {success:true,data:response.data.data}
    }else{
      return {success:false, message:response.data.message}
    }  
  })
  return response
}

export const createGroupItem = (formData) => {
  let url = `/ledger-groups/add`;
  let method = "POST"
  if(formData.id){
    url = `ledger-groups/edit/${formData.id}`
    method = 'PUT'
  }

  const response = axios({
    url:url,
    method:method,
    data:formData,
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    if(response.data.success){
      return {success:true,data:response.data.message}
    }else{
      return {success:false, message:response.data.message}
    }  
  })
  return response
}

export const ledgerGroupList = (params) => {
  let urlData = new URLSearchParams(params).toString();
  const response = axios({
    url:`/ledger-groups?${urlData}`,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    if(response.data.success){
      return {success:true,data:response.data.data}
    }else{
      return {success:false, message:response.data.message}
    }  
  })
  return response
}

export const getLedgerGrpById = (grpId) => {
  const response = axios({
    url:`/ledger-groups/get-initial-data-for-edit/${grpId}`,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8"
    }
  }).then((response)=>{
    if(response.data.success){
      return {success:true,data:response.data.data}
    }else{
      return {success:false, message:response.data.message}
    }  
  })
  return response
}

export const getLedgerDependencyData = async (params) => {
  const u = new URLSearchParams(params).toString();
  const response = await axios({
      url:`/ledgers/get-dependency-data?${u}`,
      method:"GET",
      headers:{
        "Accept-Language": "en-US,en;q=0.8"
      }
    })
  return response
}